const en_translations = {
    upload : 'upload',
    products: "products",
    pay: "pay",
    total: "total",
    logout: "logout",
    add: "add",
    added: "added",
    users: "users",
    payment: "payment",
    users: "users",
    delete: "delete",
    update: "update",
    all: "all",
    fruits: "fruits",
    dairy: "dairy",
    juices: "juices",
    bread: "bread",
    salt : 'salt',
    meat: "meat",
    can: "can",
    other: "other",
    hello: "hello",
    low_to_high: "low to high",
    high_to_low: "high to low",
    sort_price: "sort by price",
    drinks: "drinks",
    apple: "apple",
    tuna: "tuna",
    fish: "fish",
    sweetcorn: "sweet corn",
    ribs: "ribs",
    milk: "milk",
    water: "water",
    bread: "bread",
    watermelon: "watermelon",
    eggs: "eggs",
    sugar: "sugar",
    cheese: "cheese",
    about : 'about'
  }
  export default en_translations